import { mutationNames } from '@/store/storeKey'
// import { Get } from '@/modules/requester/index'
import api from '@/modules/api'

export default {
  namespaced: true,
  state: {
    rssFeed: {
      Id: null,
      PageTitle: null,
      RSSFeedURL: null,
      SubscriptionModule_Id: 0
    }
  },
  getters: {
    RssFeed: state => state.rssFeed
  },
  mutations: {
    setRssFeed (state, RssFeed) {
      state.rssFeed.RSSFeedURL = RssFeed
    },
    [mutationNames.SET_RSSFEEDDATA] (state, rssFeed) {
      state.rssFeed = rssFeed
    },
    [mutationNames.UPDATE_RSSFEEDDATA] (state, obj) {
      Object.assign(state.rssFeed, obj)
    }
  },
  actions: {
    async getRssFeedModule ({ commit, getters }, SubscriptionModuleId) {
      const response = await api.AppModules.GetRssFeedInfo(SubscriptionModuleId)
      commit(mutationNames.SET_RSSFEEDDATA, response)
    },
    async getRssFeedDate ({ commit, getters }, key) {
      const response = await api.AppModules.GetRssFeedDate(key)
      return response
    },
    updateRssFeedInfo ({ commit, getters }, payload) {
      commit(mutationNames.UPDATE_RSSFEEDDATA, payload)
    },
    async saveRssFeedInfo ({ dispatch, getters }, SubscriptionModuleId) {
      let StreamClone = Object.assign({}, getters.RssFeed)
      await api.AppModules.SaveRssFeedInfo(StreamClone)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/appModules/rssfeed.js